module.exports = __webpack_public_path__ + "fonts/xjAJXh38I15wypJXxuGMBqE8kM4xWR1_1bYURRojRGc.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/xjAJXh38I15wypJXxuGMBqE8kM4xWR1_1bYURRojRGc.woff2
// module id = 411
// module chunks = 0